import { action, makeObservable, observable } from 'mobx';

import Auth from './AuthManager';

const CONTEXT_HELP_ENDPOINTS = {
  FETCH_CONTEXT_HELP: '/api/viewContextHelp'
}

export class ContextHelpManager {
  constructor() {
      makeObservable(this);
  }

  @observable contextHelpMap = new Map();

  @action fetchContextHelp = async (id) => {
    try {
      const { FETCH_CONTEXT_HELP } = CONTEXT_HELP_ENDPOINTS;  
      const response = await Auth.fetch(`${Auth.ecms}${FETCH_CONTEXT_HELP}?contextHelpId=${id}`, {
        method: 'GET'
      });
      if (response.status === 'SUCCESS' && response.contextHelps[0]) {
        this.contextHelpMap.set(id, response.contextHelps[0].body);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  }
    
}

export default new ContextHelpManager();